import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
});

const TOKEN_KEY = "bordromat_token";

export function getToken() {
  try { return localStorage.getItem(TOKEN_KEY) || ""; } catch { return ""; }
}
export function setToken(t) {
  try {
    if (t) localStorage.setItem(TOKEN_KEY, t);
    else localStorage.removeItem(TOKEN_KEY);
  } catch {}
}

// Attach Authorization header for every outgoing request
api.interceptors.request.use((config) => {
  const token = getToken();
  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Global 401 → fire event so AuthProvider can clear state
api.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err?.response?.status === 401 && getToken()) {
      setToken("");
      const d = err.response.data?.detail;
      if (typeof d === "string" && d.includes("Şifre değiştirildiği")) sessionStorage.setItem("logout_reason", d);
      try { window.dispatchEvent(new Event("auth:logout")); } catch {}
    }
    const cfg = err?.config;
    const st = err?.response?.status;
    const transient = !err?.response || st >= 500;
    if (cfg && (cfg.method || "get").toLowerCase() === "get" && !cfg._retried && transient && !axios.isCancel(err)) {
      cfg._retried = true;
      return new Promise((r) => setTimeout(r, 1500)).then(() => api(cfg));
    }
    return Promise.reject(err);
  }
);

export const AYLAR = [
  { v: 1, n: "Ocak" }, { v: 2, n: "Şubat" }, { v: 3, n: "Mart" },
  { v: 4, n: "Nisan" }, { v: 5, n: "Mayıs" }, { v: 6, n: "Haziran" },
  { v: 7, n: "Temmuz" }, { v: 8, n: "Ağustos" }, { v: 9, n: "Eylül" },
  { v: 10, n: "Ekim" }, { v: 11, n: "Kasım" }, { v: 12, n: "Aralık" },
];

export const formatTL = (val) => {
  const num = Number(val || 0);
  return new Intl.NumberFormat("tr-TR", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(num) + " ₺";
};

export const formatNum = (val) => {
  const num = Number(val || 0);
  return new Intl.NumberFormat("tr-TR", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(num);
};

/**
 * Safely extract a human-readable error message from an axios error.
 * Handles FastAPI 422 payloads where `detail` is an array of Pydantic
 * error objects ({type, loc, msg, input, url}) so React never receives
 * raw objects as children (which would crash with "Objects are not valid
 * as a React child").
 */
export const extractErrorMessage = (err, fallback = "Bir hata oluştu") => {
  const detail = err?.response?.data?.detail;
  if (!detail) return err?.message || fallback;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) {
    const parts = detail
      .map((d) => {
        if (typeof d === "string") return d;
        const msg = d?.msg || d?.message || "";
        const loc = Array.isArray(d?.loc) ? d.loc.filter((x) => x !== "body").join(".") : "";
        return loc ? `${loc}: ${msg}` : msg;
      })
      .filter(Boolean);
    return parts.join(" · ") || fallback;
  }
  if (typeof detail === "object") {
    return detail.msg || detail.message || JSON.stringify(detail);
  }
  return String(detail);
};

export const openPdf = async (path) => {
  const w = window.open("", "_blank");
  try {
    const r = await api.get(path, { responseType: "blob", timeout: 0 });
    const url = window.URL.createObjectURL(new Blob([r.data], { type: "application/pdf" }));
    if (w) w.location.href = url; else window.location.href = url;
  } catch {
    if (w) w.close();
    window.alert("PDF açılamadı, tekrar deneyin");
  }
};

export const fmtDate = (v) => {
  if (!v || typeof v !== "string") return v;
  const m = v.match(/^(\d{4})-(\d{2})-(\d{2})/);
  return m ? `${m[3]}.${m[2]}.${m[1]}` : v;
};
